var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"expandable-input",class:{
    'is-align-right':_vm.alignRight,
    'is-small':_vm.isSmall,
    'is-large':_vm.isLarge,
    },attrs:{"role":"textbox","contenteditable":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }